const options = { day: "numeric", month: "short", year: "2-digit" };
const withTimeOptions = {
  ...options,
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  hour12: false,
};

export function getFormattedDate(date) {
  return new Date(date).toLocaleString("en-GB", options);
}

export function getFormattedDateWithTime(date) {
  return new Date(date).toLocaleString("en-GB", withTimeOptions);
}
